import Swiper from 'swiper';

export default function fullWidthSliderInit() {
  let time = $('[data-time]').attr('data-time');
  function progressBar() {
    $('.progressBar').css({'width':'0', 'transition': '0ms'});
    setTimeout(function () {
      $('.progressBar').css({'width':'100%', 'transition': time + 'ms linear'});
    }, 100);
  }
  function progressWidth() {
    $('.progress').width($('.container').width());
  }
  let fullWidthSlider = new Swiper ('.full-width-slider', {
    init: false,
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: time,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
  fullWidthSlider.on('init', function() {
    progressBar(time);
    progressWidth();
  });
  fullWidthSlider.init();
  fullWidthSlider.on('slideChange', function () {
    progressBar();
  });
  window.resize = progressWidth;
}



// WEBPACK FOOTER //
// ./scripts/partials/full-width-slider.js